<template>
  <v-app>
    <Drawer />
    <Toolbar />

    <v-content>
      <router-view :layout.sync="layout"/>
    </v-content>
  </v-app>
</template>

<script>
import Drawer from '../TheDrawer'
import Toolbar from '../TheToolbar'

export default {
  name: 'App',
  components: {
    Drawer,
    Toolbar
  },
  data () {
    return {
      //
    }
  }
}
</script>
